import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fillOpacity: '0.87',
  },
});

const ParcelIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon} fill="white">
      <path
        d="M10.701 2.29333L19.821 7.46667L18.1143 8.38667L9.10101 3.21333L10.701 2.29333ZM18.941 10.2133L20.941 9.13333V17.3333L13.941 21.3333V12.9067L15.941 11.8267V14.6667L18.941 12.9733V10.2133ZM16.0343 16.48L15.6877 16.68V18.4L16.0343 18.2V16.48ZM16.621 16.1467L16.2743 16.3467V18.0667L16.621 17.8667V16.1467ZM17.4343 15.68L17.101 15.88V17.6L17.4343 17.4V15.68ZM18.0077 15.36L17.6743 15.5467V17.3333L18.0077 17.1467V15.36ZM18.5943 15.0267L18.2477 15.2267V16.9467L18.5943 16.7467V15.0267ZM19.101 16.4533L19.4343 16.2667V14.5467L19.101 14.7333V16.4533ZM5.98101 4.84L3.94101 6L12.9543 11.1733L14.9677 10.08L5.98101 4.84ZM22.941 6.94667L10.7143 0L0.94101 5.52V17.0267L13.1943 24L22.941 18.4533V6.94667ZM11.941 20.9867L2.94101 15.8533V7.66667L11.941 12.8933V20.9867Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};

export default memo(ParcelIcon);
